import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Goal } from '../../services/goalsService';

interface GoalProgressChartProps {
  goal: Goal;
}

export default function GoalProgressChart({ goal }: GoalProgressChartProps) {
  // Parse progress data from JSON
  const progressData = goal.progressData as any[] || [];
  
  // If no progress data, create a single point with current state
  const chartData = progressData.length > 0 
    ? progressData.map((point: any) => ({
        date: new Date(point.date).toLocaleDateString('ro-RO', { month: 'short', day: 'numeric' }),
        value: point.value,
        target: goal.targetValue,
      }))
    : [{
        date: new Date(goal.createdAt).toLocaleDateString('ro-RO', { month: 'short', day: 'numeric' }),
        value: goal.currentValue,
        target: goal.targetValue,
      }];

  if (chartData.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500 text-sm">
        Nu există date de progres încă
      </div>
    );
  }

  return (
    <div className="w-full h-64">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={chartData}
          margin={{ top: 5, right: 20, left: 0, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis 
            dataKey="date" 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <YAxis 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
            label={{ 
              value: goal.unit || '', 
              angle: -90, 
              position: 'insideLeft',
              style: { fontSize: '12px', fill: '#6b7280' }
            }}
          />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '12px'
            }}
            formatter={(value: number) => [`${value} ${goal.unit || ''}`, '']}
          />
          <Legend 
            wrapperStyle={{ fontSize: '12px' }}
          />
          <Line 
            type="monotone" 
            dataKey="value" 
            stroke="#3b82f6" 
            strokeWidth={3}
            dot={{ fill: '#3b82f6', r: 4 }}
            name="Valoare Curentă"
          />
          {goal.targetValue && (
            <Line 
              type="monotone" 
              dataKey="target" 
              stroke="#10b981" 
              strokeWidth={2}
              strokeDasharray="5 5"
              dot={false}
              name="Țintă"
            />
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
